 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		1: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","2":"36bcf0ca","3":"9caf1bfd","5":"component---src-pages-aboutme-mdx","6":"component---src-pages-beginner-mdx","7":"component---src-pages-brands-mdx","8":"component---src-pages-business-mdx","9":"component---src-pages-category-cpu-js","10":"component---src-pages-category-gpu-js","11":"component---src-pages-category-pcparts-js","12":"component---src-pages-category-pcselection-js","13":"component---src-pages-category-rank-js","14":"component---src-pages-cpu-apple-mdx","15":"component---src-pages-cpu-celeron-mdx","16":"component---src-pages-cpu-cinebench-2024-mdx","17":"component---src-pages-cpu-cinebench-r-23-mdx","18":"component---src-pages-cpu-core-i-3-mdx","19":"component---src-pages-cpu-core-i-5-mdx","20":"component---src-pages-cpu-core-i-7-mdx","21":"component---src-pages-cpu-core-i-9-mdx","22":"component---src-pages-cpu-core-i-mdx","23":"component---src-pages-cpu-cospa-mdx","24":"component---src-pages-cpu-extreme-mdx","25":"component---src-pages-cpu-gaming-cpu-mdx","26":"component---src-pages-cpu-mdx","27":"component---src-pages-cpu-notepc-mdx","28":"component---src-pages-cpu-ryzen-intel-mdx","29":"component---src-pages-cpu-ryzen-mdx","30":"component---src-pages-cpu-select-mdx","31":"component---src-pages-daigakusei-mdx","32":"component---src-pages-desktop-maker-mdx","33":"component---src-pages-drive-mdx","34":"component---src-pages-editvideo-mdx","35":"component---src-pages-electricbill-mdx","36":"component---src-pages-extention-mdx","37":"component---src-pages-fujitsu-mdx","38":"component---src-pages-gaming-note-mdx","39":"component---src-pages-gamingpc-mdx","40":"component---src-pages-gpu-cpu-bottleneck-mdx","41":"component---src-pages-gpu-geforce-mdx","42":"component---src-pages-gpu-geforce-vs-radeon-mdx","43":"component---src-pages-gpu-gpu-cospa-mdx","44":"component---src-pages-gpu-intel-arc-mdx","45":"component---src-pages-gpu-mdx","46":"component---src-pages-gpu-radeon-mdx","47":"component---src-pages-grabo-mdx","48":"component---src-pages-index-mdx","49":"component---src-pages-keyboard-mdx","50":"component---src-pages-makers-dell-mdx","51":"component---src-pages-makers-fujitsu-mdx","52":"component---src-pages-makers-lenovo-mdx","53":"component---src-pages-makers-mouse-computer-mdx","54":"component---src-pages-makers-nec-mdx","55":"component---src-pages-makers-pckoubou-mdx","56":"component---src-pages-memory-expansion-mdx","57":"component---src-pages-memory-mdx","58":"component---src-pages-mobile-12-5-mdx","59":"component---src-pages-monitor-4-k-43-inch-mdx","60":"component---src-pages-monitor-mdx","61":"component---src-pages-mouse-mdx","62":"component---src-pages-note-cospa-mdx","63":"component---src-pages-notepc-maker-mdx","64":"component---src-pages-office-mdx","65":"component---src-pages-pc-sales-mdx","66":"component---src-pages-pcmaker-mdx","67":"component---src-pages-programming-mdx","68":"component---src-pages-ssd-mdx","69":"component---src-pages-storage-mdx","70":"component---src-pages-storage-ssd-lifespan-mdx","71":"component---src-pages-storage-ssd-nvme-ahci-m-2-pcie-sata-mdx","72":"component---src-pages-storage-sshd-mdx","73":"component---src-pages-usb-type-c-mdx","74":"component---src-pages-used-mdx","75":"component---src-pages-used-pc-mdx","76":"component---src-pages-used-select-mdx","77":"component---src-pages-used-shop-mdx","78":"component---src-pages-virus-mdx","79":"component---src-pages-where-mdx","80":"component---src-pages-which-mdx","81":"component---src-pages-wireless-mdx","82":"denki","84":"hikakuTable","85":"hikakuTableGPU","86":"makerRankDescription","87":"makerRanking","88":"makerSaleTable","89":"noteMakerRanking","91":"question","92":"raderChart","93":"saleCpu","94":"saleDefault","95":"saleGpu","96":"salesTweetList"}[chunkId]||chunkId) + "-" + {"0":"449f733f32492496ff90","2":"e9be4846ed79b336ad43","3":"03ec4de5ea61218f0dae","5":"d387f8770fdfbb2fd636","6":"04d811090eefa698e562","7":"c59cac11ef9cd6f8393f","8":"471f7909e9d58d652103","9":"e7c7e150f2da992dfb2f","10":"1727716d5e5bcd2e3a80","11":"310687486138eb0108c9","12":"5255ecaf08f4aad41b83","13":"146956373b7004967b6e","14":"8ab7f496d973d69f1741","15":"9a7495b95ce6b7b77858","16":"203f808f6d72fe24492a","17":"bc1075e4588348646ff1","18":"f89ccf2503976677ac6e","19":"c2b75884e9df4cefc8c3","20":"0f028d2b4699a4153970","21":"0d446aaca4b992d8765d","22":"f7a79a85acb0c06d5db5","23":"91647b5c9f975248fbb5","24":"09ed2ea4030be80086ed","25":"c8f51584bc1316669d83","26":"49c7f3c299a45865ab9e","27":"92f7189e1fe8f4ca8604","28":"97fc4345a11099fd4c34","29":"5825e983e07d4bfe6130","30":"969b13402432f6871946","31":"3d91946e17926c4188dc","32":"670366f01818ac82f9a8","33":"4caa822e2a2ad3a39ee6","34":"ed5d1e0841998aa9779b","35":"e605a56a2a6c0b5a2aea","36":"3733f87d3e2f8d9fd2f4","37":"c0f4fc6bb4120ba8e629","38":"9db4986c35e6df0cb91c","39":"db2bd9e292018fa411fe","40":"e7336262936940eebca5","41":"2137c91b76366c84892c","42":"25104756e7fd7e5d33b5","43":"879da559fa3792692763","44":"b1970e8569afb4903626","45":"15c1be21b3dc3ecb3b8f","46":"faaf2efcc95f4b79f78b","47":"f9591252c6b9283c461c","48":"5f1140135c65593758df","49":"e4cdb9918adefa52b9d4","50":"c440ec3b7c28d5da27e7","51":"5a0175718a3a49bf0df1","52":"f9630f12a249e75c032a","53":"0e6e5cb6fd05127ade13","54":"7b2243803dda54f77cf2","55":"511823e9fa71c1108cae","56":"900a2cf3019eac18d5a6","57":"e99442c86ad3acdd9240","58":"28c6db91d6cd1a83e1eb","59":"57389a230c85b92c240e","60":"2e55672dc8a43648d40e","61":"7b68ff5591daccd964c6","62":"97044c74fc51c3f873d6","63":"23a1eec8340b9ef6a42a","64":"5cade1b4766f8e40e284","65":"0ca80549659d798d0bcd","66":"6e7d3fe8b49c09a16cdb","67":"7a27702c630ea5526f9e","68":"f914f9b227814971e4af","69":"4a273dba7c9ce24cce7a","70":"8cfbfba523a386729878","71":"c2f1fe92d49d05353db3","72":"8176aad32a6b0f9432bb","73":"a9187dcbd5e6dd4f674b","74":"8c331b0c1c36966d5b3f","75":"6808d3f9dbff65b15d39","76":"8afb1b32786b82e1c494","77":"9150fb0f3ce1957ac39c","78":"64ae8c7adcd46f081023","79":"7e301d5771dd504cf518","80":"158ba89c25d111564f4a","81":"ff6bb092317a5446e7d6","82":"d391ea3f8511ebc53e8f","84":"61c106af01a346c68546","85":"d67a2fe5ee1dc953e39c","86":"568bcc2f15d6e80131c4","87":"4fdccf34c8c1e8222c1b","88":"aa321d6a6737f7a6b1ae","89":"abf70825b03710c8ef16","91":"da3073d5098178fa1d28","92":"94900586485d3f407af0","93":"3388cb4347a2faa1c0b2","94":"1905a937b7653cb20a0d","95":"820eada54e1c4f87692a","96":"b2002882bf70cea6a0cc"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
